import React from "react";
// import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle";
// import "./landing.css"
import logo from "../../images/logonew.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
// import DatePicker from "react-datepicker";
// import { format } from 'date-fns'
// import { Col, Row } from "react-bootstrap";
// import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
// import "./Login.css"
const Register = () => {
  const [User, setUser] = useState();
  const [lastName, setlastName] = useState();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [Password, setPassword] = useState();
  const [Email, setEmail] = useState();
  const [Conf, setConf] = useState();
  const [Number, setNumber] = useState();
  const [image, setImage] = useState();
  const [Coll_ids, setColl_ids] = useState();
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [code, setCode] = useState("");
  const [userCode, setUserCode] = useState("");
  const navigate = useNavigate();
  const today = new Date();
  function Username() {
    const username = document.getElementById("name").value;
    setUser(username);
  }
  function LastName() {
    const lastName = document.getElementById("lastName").value;
    setlastName(lastName);
  }

  function Passwords() {
    const password = document.getElementById("password").value;
    setPassword(password);
  }
  function ImageUser() {
    const image = document.getElementById("myFileInput").files[0];
    setImage(image);
  }
  function Emails() {
    const confpassword = document.getElementById("email").value;
    setEmail(confpassword);
  }
  function Conpassword() {
    const password = document.getElementById("confpassword").value;
    setConf(password);
  }
  function NUmber() {
    const number = document.getElementById("number").value;
    setNumber(number);
  }
  function Coll_id() {
    const coll = document.getElementById("coll_id").value;
    setColl_ids(coll);
  }

  const sendDataVerification = () => {
    var fdata = new FormData();
    fdata.append("email", Email);
    axios
      .post("https://maps-medics-be.onrender.com/verification", fdata)
      .then((res) => {
        console.log(res.data);
        if (res.data.success === true) {
          setShowVerification(true);
        }
        setCode(res.data.code);
        console.log(res.data.code);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function SendData() {
    if (code !== userCode) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Wrong Verification Code!",
        footer: '<a href="">This account is already registered.</a>',
      });
    } else {
      if (Conf !== Password) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Password not compatibile!",
          footer: '<a href="">This account is already registered.</a>',
        });
      } else {
        // e.preventDefault()
        // const fileInput = document.getElementById('myFileInput');

        const formData = new FormData();
        formData.append("name", User + ";" + lastName);
        formData.append("password", Password);
        formData.append("email", Email);
        formData.append("number", Number);
        formData.append("collage_id", Coll_ids);
        formData.append("image", image);

        console.log(User, Password, Email, Number, Coll_ids, image);

        axios
          .post("https://maps-medics-be.onrender.com/add_student", formData)
          .then((response) => {
            let x = jwtDecode(response.data.token);
            console.log(x);
            let v = x.token;
            console.log(x.token);
            console.log(response.data);
            if (response.data.success === true) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Welcome",
                showConfirmButton: false,
                timer: 1500,
              });
              // sessionStorage.setItem("loggedIn", true);
              // sessionStorage.setItem("user_id", response.data.user_id);
              // sessionStorage.setItem("user_image", response.data.image);
              // sessionStorage.setItem("token", v);
              // sessionStorage.setItem("logged_once", true);

              sessionStorage.setItem("user_collId", response.data.collage_id);
              console.log(response.data.collage_id);
              navigate("/login");
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: '<a href="">This account is already registered.</a>',
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }
  return (
    <>
      <div
        className="section page-banner-register "
        style={{ position: "relative", height: "150vh" }}
      >
        <div
          className="container-fluid p-3"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
          }}
        >
          <div className="row">
            {/* <div className="col-md-1"></div> */}

            <div
              className="col-md-7 p-3"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <img
                  src={logo}
                  alt=""
                  class="w3-animate-opacity"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    maxWidth: "95%",
                  }}
                />
                <div className="w3-center w3-animate-top">
                  <h1
                    style={{
                      fontWeight: "900",
                      fontSize: "4em",
                      color: "#ffc600",
                      lineHeight: "1.2em",
                      fontFamily: "Playfair Display",
                      textAlign: "left",
                      marginLeft: "8%",
                      marginTop: "3%",
                    }}
                  >
                    Hi there,
                  </h1>
                  <p
                    style={{
                      margin: "0",
                      fontSize: "20px",
                      lineHeight: "1.1",
                      fontWeight: "400",
                      fontFamily: "Segoe UI",
                      color: "#000",
                      textAlign: "left",
                      marginTop: "3%",
                      marginLeft: "6%",
                    }}
                  >
                    We are happy to have you with us! just fill the form on the
                    right to enjoy our website special member benefits.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="col-md-1"></div> */}
            <div className="col-md-1"></div>
            <div
              className="col-md-4 secound 3-container w3-center w3-animate-bottom"
              style={{
                padding: "0",
                marginTop: "10%",
                width: windowSize.height < 700 ? "32%" : "d",
              }}
            >
              <h3
                className="text-center p-3"
                style={{
                  fontSize: "1.625rem",
                  color: "#ffc600",
                  lineHeight: "1.2em",
                  fontWeight: "900",
                }}
              >
                Create Account
              </h3>
              <div
                className="container-fluid"
                style={{
                  maxHeight: windowSize.height < 700 ? "45vh" : "500vh",
                  overflowY: windowSize.height < 700 ? "scroll" : "hidden",
                  maxWidth: "false",
                }}
              >
                <div
                  className="row"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {showVerification === false ? (
                    <>
                      <div className="col-md-10">
                        <div
                          style={{ paddingBottom: "2%", position: "relative" }}
                        >
                          <div style={{ margin: "auto" }}>
                            <div class="form__group field">
                              <input
                                class="form__field"
                                name="name"
                                required
                                // className="form-control p-3"

                                id="name"
                                type="text"
                                // className="form-control "
                                placeholder="First Name"
                                onChange={Username}
                              />
                              <div className="iconWrap">
                                <i class="fa-solid fa-user-doctor"></i>
                              </div>
                              <label
                                for="name"
                                class="form__label"
                                onClick={() => {
                                  document.getElementById("name").focus();
                                }}
                              >
                                Name
                              </label>
                            </div>
                          </div>
                          <div style={{ margin: "auto" }}>
                            <div class="form__group field">
                              <input
                                class="form__field"
                                name="lastName"
                                required
                                // className="form-control p-3"
                                id="lastName"
                                type="text"
                                // className="form-control "
                                placeholder="Last Name"
                                onChange={LastName}
                              />
                              <div className="iconWrap">
                                <i class="fa-solid fa-user"></i>
                              </div>
                              <label
                                for="lastName"
                                class="form__label"
                                onClick={() => {
                                  document.getElementById("lastName").focus();
                                }}
                              >
                                Last Name
                              </label>
                            </div>
                          </div>
                          {/* <div className="iconWrap">
                        <i class="fa-solid fa-at"></i>
                      </div>
                      <input
                        style={{
                          textAlign: "left",
                          borderBottom: "3px solid #ccc ",
                          padding: "12px 20px 20px 40px",
                          transition: "0.5s all",
                          color: "#666666",
                          backgroundColor: "#ffffff",
                          borderTop: "none",
                          borderRight: "none",
                          borderLeft: "none",
                        }}
                        // style={{width:'150vh',height:'7vh',marginTop:"0vh" ,textAlign:"Left"}}
                        id="name"
                        type="text"
                        // className="form-control "
                        placeholder="First Name"
                        onChange={Username}
                      /> */}
                        </div>
                        <div
                          style={{ paddingBottom: "2%", position: "relative" }}
                        >
                          <div style={{ margin: "auto" }}>
                            <div class="form__group field">
                              <input
                                class="form__field"
                                name="number"
                                required
                                // className="form-control p-3"

                                // className="form-control "

                                id="number"
                                type="number"
                                // className="form-control"
                                placeholder="Number"
                                onChange={NUmber}
                              />
                              <div className="iconWrap">
                                <i class="fa-solid fa-phone"></i>
                              </div>
                              <label
                                for="number"
                                class="form__label"
                                onClick={() => {
                                  document.getElementById("number").focus();
                                }}
                              >
                                Number
                              </label>
                            </div>
                          </div>
                          {/* <div className="iconWrap">
                        <i class="fa-solid fa-phone"></i>
                      </div>
                      <input
                        style={{
                          textAlign: "left",
                          borderBottom: "3px solid #ccc ",
                          padding: "12px 20px 20px 40px",
                          transition: "0.5s all",
                          color: "#666666",
                          backgroundColor: "#ffffff",
                          borderTop: "none",
                          borderRight: "none",
                          borderLeft: "none",
                        }}
                        // style={{width:'150vh',height:'7vh',marginTop:"0vh" ,textAlign:"Left"}}
                        id="number"
                        type="number"
                        // className="form-control"
                        placeholder="Number"
                        onChange={NUmber}
                      /> */}
                        </div>
                        <div
                          style={{ paddingBottom: "2%", position: "relative" }}
                        >
                          <div style={{ margin: "auto" }}>
                            <div class="form__group field">
                              <input
                                class="form__field"
                                name="coll_id"
                                required
                                id="coll_id"
                                type="email"
                                // className="form-control"
                                placeholder="College ID"
                                onChange={Coll_id}
                              />
                              <div className="iconWrap">
                                <i class="fa-solid fa-address-card"></i>
                              </div>
                              <label
                                for="coll_id"
                                class="form__label"
                                onClick={() => {
                                  document.getElementById("coll_id").focus();
                                }}
                              >
                                College ID
                              </label>
                            </div>
                          </div>
                          {/* <div className="iconWrap">
                        <i class="fa-solid fa-user"></i>
                      </div>
                      <input
                        style={{
                          textAlign: "left",
                          borderBottom: "3px solid #ccc ",
                          padding: "12px 20px 20px 40px",
                          transition: "0.5s all",
                          color: "#666666",
                          backgroundColor: "#ffffff",
                          borderTop: "none",
                          borderRight: "none",
                          borderLeft: "none",
                        }}
                        // style={{width:'150vh',height:'7vh',marginTop:"0vh" ,textAlign:"Left"}}
                        id="coll_id"
                        type="email"
                        // className="form-control"
                        placeholder="College ID"
                        onChange={Coll_id}
                      /> */}
                        </div>
                        <div
                          style={{ paddingBottom: "2%", position: "relative" }}
                        >
                          <div style={{ margin: "auto" }}>
                            <div class="form__group field">
                              <input
                                class="form__field"
                                name="email"
                                required
                                id="email"
                                type="email"
                                placeholder="E-Mail"
                                onChange={Emails}
                              />
                              <div className="iconWrap">
                                <i class="fa-solid fa-envelope"></i>
                              </div>
                              <label
                                for="email"
                                class="form__label"
                                onClick={() => {
                                  document.getElementById("email").focus();
                                }}
                              >
                                Email
                              </label>
                            </div>
                          </div>
                          {/* <div className="iconWrap">
                        <i class="fa-solid fa-envelope"></i>
                      </div>
                      <input
                        style={{
                          textAlign: "left",
                          borderBottom: "3px solid #ccc ",
                          padding: "12px 20px 20px 40px",
                          transition: "0.5s all",
                          color: "#666666",
                          backgroundColor: "#ffffff",
                          borderTop: "none",
                          borderRight: "none",
                          borderLeft: "none",
                        }}
                        // style={{width:'150vh',height:'7vh',marginTop:"0vh" ,textAlign:"Left"}}
                        id="email"
                        type="email"
                        // className="form-control"
                        placeholder="E-Mail"
                        onChange={Emails}
                      />{" "} */}
                        </div>
                        <div
                          style={{ paddingBottom: "2%", position: "relative" }}
                        >
                          <div style={{ margin: "auto" }}>
                            <div class="form__group field">
                              <input
                                class="form__field"
                                name="password"
                                required
                                id="password"
                                type={show1 ? "text" : "Password"}
                                placeholder="Password"
                                onChange={Passwords}
                              />
                              <div className="iconWrap">
                                <i class="fa-solid fa-lock"></i>
                              </div>
                              <div
                                className="ourx"
                                onClick={() => {
                                  setShow1(!show1);
                                }}
                              >
                                <i
                                  class="fa fa-eye fa-2xs"
                                  aria-hidden="true"
                                  style={{ color: show1 ? "#ffc600" : "black" }}
                                ></i>
                              </div>
                              <label
                                for="password"
                                class="form__label"
                                onClick={() => {
                                  document.getElementById("password").focus();
                                }}
                              >
                                Password
                              </label>
                            </div>
                          </div>
                          {/* <div className="iconWrap">
                        <i class="fa-solid fa-lock"></i>
                      </div>
                      <input
                        style={{
                          textAlign: "left",
                          borderBottom: "3px solid #ccc ",
                          padding: "12px 20px 20px 40px",
                          transition: "0.5s all",
                          color: "#666666",
                          backgroundColor: "#ffffff",
                          borderTop: "none",
                          borderRight: "none",
                          borderLeft: "none",
                        }}
                        // style={{width:'150vh',height:'7vh',marginTop:"0vh" ,textAlign:"Left"}}
                        id="password"
                        type="Password"
                        // className="form-control"
                        placeholder="Password"
                        onChange={Passwords}
                      />{" "} */}
                        </div>
                        <div
                          style={{ paddingBottom: "2%", position: "relative" }}
                        >
                          <div style={{ margin: "auto" }}>
                            <div class="form__group field">
                              <input
                                class="form__field"
                                name="confpassword"
                                required
                                id="confpassword"
                                type={show2 ? "text" : "Password"}
                                // className="form-control"
                                placeholder="Password confirmation"
                                onChange={Conpassword}
                              />
                              <div className="iconWrap">
                                <i class="fa-solid fa-lock"></i>
                              </div>
                              <div
                                className="ourx"
                                onClick={() => {
                                  setShow2(!show2);
                                }}
                              >
                                <i
                                  class="fa fa-eye fa-2xs"
                                  style={{ color: show2 ? "#ffc600" : "black" }}
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <label
                                for="confpassword"
                                class="form__label"
                                onClick={() => {
                                  document
                                    .getElementById("confpassword")
                                    .focus();
                                }}
                              >
                                Confirm Password
                              </label>
                            </div>
                          </div>

                          <div class="form__group field">
                            <label for="myFileInput" class="form__label">
                              Select an image:
                            </label>
                            <input
                              type="file"
                              id="myFileInput"
                              name="image"
                              onChange={ImageUser}
                              class="form__field_choose"
                            />
                          </div>
                          {/* <div className="iconWrap">
                        <i class="fa-solid fa-lock"></i>
                      </div>
                      <input
                        style={{
                          textAlign: "left",
                          borderBottom: "3px solid #ccc ",
                          padding: "12px 20px 20px 40px",
                          transition: "0.5s all",
                          color: "#666666",
                          backgroundColor: "#ffffff",
                          borderTop: "none",
                          borderRight: "none",
                          borderLeft: "none",
                        }}
                        // style={{width:'150vh',height:'7vh',marginTop:"0vh" ,textAlign:"Left"}}
                        id="confpassword"
                        type="Password"
                        // className="form-control"
                        placeholder="Password confirmation"
                        onChange={Conpassword}
                      />{" "} */}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <p style={{ fontFamily: "Poppins", fontSize: "18px" }}>
                          Please write the verification code sent to {Email}
                        </p>
                        <input
                          type="text"
                          className="form-control"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                          onChange={(e) => setUserCode(e.target.value)}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div style={{ padding: "0", marginTop: "4%" }}>
                <a
                  href="/terms"
                  style={{
                    color: "#FFCF27",
                    textDecoration: "none",
                    display: "flex",
                    fontSize: "17px",
                    marginLeft: "10%",
                    paddingTop: "5%",
                  }}
                >
                  Show privacy policy
                </a>

                <br />

                {showVerification === false ? (
                  <>
                    <div style={{ marginTop: "1vh" }}>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                        style={{
                          paddingLeft: "10px",
                          fontSize: "19px",
                          textAlign: "start",
                          fontFamily: "Poppins",
                        }}
                      >
                        Please confirm that you agree to <br /> our privacy
                        policy{" "}
                      </label>
                    </div>

                    <button
                      style={{
                        marginTop: "7%",
                        // background: "#242A56",
                        // width: "40%",
                        // border: "1px solid #242A56",
                        marginBottom: "7%",
                      }}
                      onClick={() => sendDataVerification()}
                      type="submit"
                      className="btn startLearningAdver"
                    >
                      Create Account
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      style={{
                        marginTop: "7%",
                        // background: "#242A56",
                        width: "30%",
                        // border: "1px solid #242A56",
                        marginBottom: "7%",
                      }}
                      onClick={() => SendData()}
                      type="submit"
                      className="btn startLearningAdver"
                    >
                      Verify
                    </button>
                  </>
                )}
                <div
                  className="p-3"
                  style={{
                    backgroundColor: "#000",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <label
                    style={{
                      color: "#fff",
                      marginRight: "5px",
                      fontWeight: "900",
                    }}
                  >
                    Already have an account?
                  </label>
                  <a
                    href="/login"
                    style={{ color: "#ffc600", textDecoration: "none" }}
                  >
                    Login Here
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="" style={{ position: "absolute", bottom: "0px" }}>
            <div className="container">
              <div
                className="row p-2"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {/* <div className="col-md-6 ">
              <div className="row" style={{ display: "block" }}>
                <a
                  href="https://neoneg.com/"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    cursor: "pointer",
                    color: "white",
                  }}
                >
                  www.neoneg.com
                </a>
              
              </div>
            </div> */}
                <div
                  className="col-md-12"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <p
                    style={{
                      margin: "0",
                      fontSize: "15px",
                      lineHeight: "1.8",
                      fontWeight: "700",
                      fontFamily: "Segoe UI",
                      color: "#000",
                    }}
                  >
                    Copyright &copy; {today.getFullYear()} by{" "}
                    <span>
                      {" "}
                      <a
                        href="https://neoneg.com/"
                        style={{
                          cursor: "pointer",
                          textDecoration: "none",
                          color: "#000",
                          fontWeight: "700",
                        }}
                      >
                        NEON
                      </a>{" "}
                    </span>
                    <a
                      href=""
                      style={{ textDecoration: "none", fontWeight: "700" }}
                      onClick={() => {
                        window.open(`https://wa.me/+201113588988`);
                      }}
                    >
                      <i
                        className="fa-brands fa-whatsapp fs-5"
                        style={{ color: "#000", marginRight: "10px" }}
                      ></i>
                    </a>{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="first"><img src={logo} alt="neon" className="ad" /></div>
        <hr style={{color:"gray" ,fontSize:20}}/> */}
        </div>
      </div>
    </>
  );
};
export default Register;
